<div class="ccl-custom-datefield" [class.ccl-custom-datefield--disabled]="disabled">
  <div class="ccl-custom-datefield__wrapper" (click)="onWrapperClick($event)">
    <input
      type="text"
      class="ccl-custom-datefield__input"
      [placeholder]="placeholder"
      [value]="displayValue"
      [disabled]="disabled"
      [attr.aria-required]="required"
      aria-label="Date input"
      (input)="onTextInput($event)"
      (blur)="onBlur()"
    />

    <button
      type="button"
      class="ccl-custom-datefield__icon"
      aria-label="Open calendar"
      [disabled]="disabled"
      (click)="onIconClick($event)"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM6 3V1h2v2h8V1h2v2h2a2 2 0 012 2v14a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2zm14 16V8H4v11z"
        />
      </svg>
    </button>
    @if (displayValue) {
      <button
        type="button"
        class="ccl-custom-datefield__clear"
        aria-label="Clear date"
        (click)="onClearClick($event)"
        [disabled]="disabled"
      >
        ✕
      </button>
    }
  </div>

  @if (errorMessage) {
    <div class="ccl-custom-datefield__error">
      {{ errorMessage }}
    </div>
  }

  <input
    #nativePicker
    [type]="showTime ? 'datetime-local' : 'date'"
    class="ccl-custom-datefield__picker"
    [disabled]="disabled"
    [min]="getMinDateString()"
    [max]="getMaxDateString()"
    (change)="onNativeChange($event)"
  />
</div>
